export namespace BoardDisabled {
  export namespace Plugin {
    export const Name = 'board-disabled';
  }
}
